/* ==========================================================================
   Ferme Comet-Tournier — Theme JS
   ========================================================================== */
(function () {
  'use strict';

  const routes = window.themeRoutes || {};
  const strings = window.themeStrings || {};

  /* ---------- Helpers ---------- */
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) => {
    const fmt = window.themeMoneyFormat || '{{amount}} €';
    const value = (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, value);
  };

  let scrollLockCount = 0;
  function lockScroll() { scrollLockCount++; document.body.classList.add('is-locked'); }
  function unlockScroll() { scrollLockCount = Math.max(0, scrollLockCount - 1); if (scrollLockCount === 0) document.body.classList.remove('is-locked'); }

  /* ---------- Header scroll state ---------- */
  const header = $('.header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Generic drawer controller ---------- */
  function setupDrawer(drawer) {
    if (!drawer) return null;
    const open = () => { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); lockScroll(); };
    const close = () => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); unlockScroll(); };
    $$('[data-drawer-close]', drawer).forEach((b) => b.addEventListener('click', close));
    const overlay = $('[data-drawer-overlay]', drawer);
    if (overlay) overlay.addEventListener('click', close);
    return { open, close, el: drawer };
  }

  const mobileMenu = setupDrawer($('#mobile-menu'));
  const searchDrawer = setupDrawer($('#search-drawer'));
  const cartDrawerEl = $('#cart-drawer');
  const cartDrawer = setupDrawer(cartDrawerEl);

  $$('[data-open-menu]').forEach((b) => b.addEventListener('click', () => mobileMenu && mobileMenu.open()));
  $$('[data-open-search]').forEach((b) => b.addEventListener('click', () => {
    if (searchDrawer) { searchDrawer.open(); setTimeout(() => { const i = $('input[type="search"]', searchDrawer.el); if (i) i.focus(); }, 250); }
  }));
  $$('[data-open-cart]').forEach((b) => b.addEventListener('click', (e) => {
    if (cartDrawer) { e.preventDefault(); cartDrawer.open(); }
  }));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      [mobileMenu, searchDrawer, cartDrawer].forEach((d) => d && d.el.classList.contains('is-open') && d.close());
    }
  });

  /* ---------- Accordions ---------- */
  $$('.accordion__trigger').forEach((trigger) => {
    const panel = trigger.nextElementSibling;
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      panel.style.maxHeight = expanded ? null : panel.scrollHeight + 'px';
    });
    if (trigger.getAttribute('aria-expanded') === 'true') {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  });

  /* ---------- Quantity selectors ---------- */
  $$('[data-qty]').forEach((wrap) => {
    const input = $('input', wrap);
    if (!input) return;
    $$('[data-qty-btn]', wrap).forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = btn.dataset.qtyBtn === 'plus' ? 1 : -1;
        const min = parseInt(input.min || '1', 10);
        let val = parseInt(input.value || '1', 10) + step;
        if (val < min) val = min;
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Reveal on scroll ---------- */
  const reveals = $$('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  /* ============================================================
     CART
     ============================================================ */
  const cartCountEls = () => $$('[data-cart-count]');

  function updateCartCount(count) {
    cartCountEls().forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCartDrawer(cart) {
    if (!cartDrawerEl) return;
    const body = $('[data-cart-body]', cartDrawerEl);
    const foot = $('[data-cart-foot]', cartDrawerEl);
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = `
        <div class="cart-empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 3h2l.4 2M7 13h10l3-8H6.4M7 13L5.4 5M7 13l-2 4h12" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9" cy="20" r="1"/><circle cx="17" cy="20" r="1"/></svg>
          <p>${strings.cartEmpty || 'Votre panier est vide.'}</p>
          <a href="${routes.all_products || '/collections/all'}" class="btn btn--secondary mt-3">${strings.continueShopping || 'Voir la boutique'}</a>
        </div>`;
      if (foot) foot.hidden = true;
      return;
    }

    if (foot) foot.hidden = false;
    body.innerHTML = cart.items.map((item, index) => {
      const img = item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, '_160x$1') : '';
      const variant = item.product_has_only_default_variant ? '' : `<div class="cart-line__variant">${item.variant_title || ''}</div>`;
      return `
      <div class="cart-line" data-line="${index + 1}" data-key="${item.key}">
        <a href="${item.url}" class="cart-line__media">${img ? `<img src="${img}" alt="" loading="lazy" width="72" height="84">` : ''}</a>
        <div class="cart-line__info">
          <a href="${item.url}" class="cart-line__title">${item.product_title}</a>
          ${variant}
          <div class="cart-line__bottom">
            <div class="cart-line__qty" data-line-qty>
              <button type="button" data-line-change="-1" aria-label="Réduire">&minus;</button>
              <span>${item.quantity}</span>
              <button type="button" data-line-change="1" aria-label="Augmenter">+</button>
            </div>
            <div class="cart-line__price">${money(item.final_line_price)}</div>
          </div>
          <button type="button" class="cart-line__remove" data-line-remove>${strings.remove || 'Retirer'}</button>
        </div>
      </div>`;
    }).join('');

    const totalEl = $('[data-cart-total]', cartDrawerEl);
    if (totalEl) totalEl.textContent = money(cart.total_price);

    bindCartLineEvents();
  }

  function bindCartLineEvents() {
    if (!cartDrawerEl) return;
    $$('.cart-line', cartDrawerEl).forEach((line) => {
      const key = line.dataset.key;
      const span = $('[data-line-qty] span', line);
      $$('[data-line-change]', line).forEach((btn) => {
        btn.addEventListener('click', () => {
          const delta = parseInt(btn.dataset.lineChange, 10);
          const qty = Math.max(0, parseInt(span.textContent, 10) + delta);
          changeCart(key, qty);
        });
      });
      const rm = $('[data-line-remove]', line);
      if (rm) rm.addEventListener('click', () => changeCart(key, 0));
    });
  }

  async function fetchCart() {
    const res = await fetch(`${routes.cart || '/cart'}.js`, { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function changeCart(key, quantity) {
    if (cartDrawerEl) cartDrawerEl.classList.add('is-busy');
    try {
      const res = await fetch(`${routes.cart_change || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      const cart = await res.json();
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      // If on cart page, reload to reflect changes
      if (document.body.classList.contains('template-cart')) window.location.reload();
    } finally {
      if (cartDrawerEl) cartDrawerEl.classList.remove('is-busy');
    }
  }

  async function addToCart(form, button) {
    const formData = new FormData(form);
    if (button) { button.classList.add('is-loading'); button.disabled = true; }
    try {
      const res = await fetch(`${routes.cart_add || '/cart/add'}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      if (!res.ok) {
        const err = await res.json();
        showFormError(form, err.description || strings.addError || 'Une erreur est survenue.');
        return;
      }
      const cart = await fetchCart();
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      if (cartDrawer) cartDrawer.open();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (e) {
      showFormError(form, strings.addError || 'Une erreur est survenue.');
    } finally {
      if (button) { button.classList.remove('is-loading'); button.disabled = false; }
    }
  }

  function showFormError(form, message) {
    let box = $('[data-form-error]', form);
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-form-error', '');
      box.className = 'notice notice--error mt-2';
      form.appendChild(box);
    }
    box.textContent = message;
  }

  // Bind all add-to-cart forms (product page, cards, sections)
  $$('form[action$="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = $('[type="submit"]', form);
      addToCart(form, btn);
    });
  });

  // Init cart count from data attribute already rendered; nothing else needed.
  document.addEventListener('cart:render-request', () => fetchCart().then(renderCartDrawer));

})();
